import Tooltip from 'bootstrap/js/dist/tooltip'

/**
 * Configure an element to copy its text content to the user's clipboard when clicked or tapped.
 */
export function configureCopyToClipboard(element: HTMLElement) {
  const tooltip = new Tooltip(element, {
    title: 'Copied to clipboard',
    trigger: 'hover',
    delay: { show: 0, hide: 500 },
  })

  // Disable tooltip until the element is clicked.
  tooltip.disable()

  element.addEventListener('click', () => {
    element.focus()
    if (!element.dataset.copyClipboard) {
      return
    }
    const copyClipboard = element.dataset.copyClipboard
    element.addEventListener('hidden.bs.tooltip', () => {
      // Once hidden (i.e. the user mouses out of the element), disable the tooltip
      // until the next event.
      tooltip.disable()
    })
    navigator.clipboard.writeText(copyClipboard).then(() => {
      tooltip.enable()
      tooltip.show()
    })
  })
}
